import { render, staticRenderFns } from "./Align.vue?vue&type=template&id=7f6980f4&functional=true"
import script from "./Align.vue?vue&type=script&lang=js"
export * from "./Align.vue?vue&type=script&lang=js"
import style0 from "./Align.vue?vue&type=style&index=0&id=7f6980f4&prod&lang=scss&module=true"




function injectStyles (context) {
  
  this["$style"] = (style0.locals || style0)

}

/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  true,
  injectStyles,
  null,
  null
  
)

export default component.exports